import { KnowledgeSource } from './knowledge-source';

export const NEW_CHAT_ID = '00000000-0000-0000-0000-000000000000';

export interface ApiResponse<T> { success: boolean; value: T; }
export const translationLanguages = [
  { label: 'Português', value: 'pt-br' },
  { label: 'English', value: 'en' },
  { label: 'Español', value: 'es' },
  { label: 'Deutsch', value: 'de' },
] as const;
export type TranslationLanguage = typeof translationLanguages[number]['value'];
/** messageFileId is always MessagesFiles.Id, never a Search/chunk or language-file ID. */
export interface DocumentTranslationContext { chatId: string; messageId: string; messageFileId: string; }
export interface TranslateDocumentRequest extends DocumentTranslationContext { languageTo: TranslationLanguage; }
/** Locates the reference within its message; these IDs must never enter MessageFileId. */
export interface DocumentReferenceContext { chatId: string; messageId: string; chunkId: string; documentId: string; }
export interface PdfDocumentPreview { url: string; title: string; displayName: string | null; translationContext?: DocumentReferenceContext; }
export interface ChatSummary { id: string; title: string; }
/** History returns MessagesFiles.Id; legacy SSE may return a Search ID in id. */
export interface ChatFile { id: string; chunkId: string; displayName: string; documentId: string; }
export type UserReaction = 0 | 1 | 2;
export interface Message {
  id: string; text: string; user: string; date: string; userMessage: boolean;
  dislike: boolean; userReaction?: UserReaction; messageFiles: ChatFile[]; streaming?: boolean;
}
export interface ChatDetail { id: string; messages: Message[]; }
export interface ChatRequest { chatId: string; text: string; knowledgeSources: KnowledgeSource[]; }
export interface PipelineProgress { step: string; message: string; order: number; }
export interface Settings {
  timeZoneId: string;
  language: 'english' | 'spanish' | 'german' | 'brazil';
  darkMode: boolean;
  knowledgeSources: KnowledgeSource[];
  indexes?: string[];
  index?: string;
}
export type SettingsDto = Omit<Settings, 'knowledgeSources'> & { knowledgeSources?: unknown };

export interface StreamMessageDto {
  Id: string; Text: string; User: string; Date: string; UserMessage: boolean; Dislike: boolean;
  UserReaction?: UserReaction; MessageFiles?: StreamFileDto[];
}
/** Legacy SSE can put the Search ID in Id; resolve the persisted file before translation. */
export interface StreamFileDto { Id: string; ChunkId: string; DisplayName: string; DocumentId: string; }
export interface StreamFinalData { FolderId: string; Asc: StreamMessageDto; Message: StreamMessageDto; }
export type ChatStreamEvent =
  | { type: 'error' }
  | { type: 'progress'; step: string; message: string; order: number }
  | { type: 'token'; message: string }
  | { type: 'final'; data: StreamFinalData };

export function mapStreamMessage(dto: StreamMessageDto): Message {
  return {
    id: dto.Id, text: dto.Text, user: dto.User, date: dto.Date, userMessage: dto.UserMessage,
    dislike: dto.Dislike, userReaction: dto.UserReaction,
    messageFiles: (dto.MessageFiles ?? []).map(file => ({
      id: file.Id, chunkId: file.ChunkId, displayName: file.DisplayName, documentId: file.DocumentId,
    })),
  };
}
